import { get, setLanguage } from "../../i18n";

class {
  onInput(input) {
    if (input.lang) {
      setLanguage(input.lang);
    }
  }
}

<div class="p-2 xs:p-4 sm:p-6">
  <Card class="max-w-5xl mx-auto px-4 py-10 mt-4 prose prose-invert prose-lg" title=get("learn.title") main="true">
    <p class="lead text-gray-300 mb-8">${get("learn.intro")}</p>

    <!-- What are file permissions -->
    <section id="what-are-permissions" class="mb-8 border-b-3 border-gray-600 pb-4">
      <h2 class="text-3xl font-semibold mb-3 text-slate-400">${get("learn.whatArePermissions.title")}</h2>
      <for|para| of=get("learn.whatArePermissions.content")>
        <span>${para} </span>
      </for>
    </section>

    <!-- User types -->
    <section id="user-types" class="mb-8 border-b-3 border-gray-600 pb-4">
      <h2 class="text-3xl font-semibold mb-3 text-slate-400">${get("learn.userTypes.title")}</h2>
      <p class="mb-4">${get("learn.userTypes.intro")}</p>
      <ul class="pl-0 list-none grid grid-cols-1 md:grid-cols-3 gap-3">
        <for|item| of=get("learn.userTypes.points")>
          <li class="bg-slate-900 rounded-lg p-4 border border-gray-700">
            <h3 class="text-xl font-bold mb-2">${item.name}</h3>
            <p>${item.description}</p>
          </li>
        </for>
      </ul>
    </section>

    <!-- Permission types -->
    <section id="permission-types" class="mb-8 border-b-3 border-gray-600 pb-4">
      <h2 class="text-3xl font-semibold mb-3 text-slate-400">${get("learn.permissionTypes.title")}</h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
        <for|perm| of=get("learn.permissionTypes.items")>
          <div class="bg-slate-900 rounded-lg p-4 border border-gray-700">
            <h3 class="text-xl font-bold mb-2">${perm.name}</h3>
            <p>${perm.description}</p>
          </div>
        </for>
      </div>
    </section>

    <!-- chmod intro -->
    <section id="chmod-intro" class="mb-8 border-b-3 border-gray-600 pb-4">
      <h2 class="text-3xl font-semibold mb-3 text-slate-400">${get("learn.chmodIntro.title")}</h2>
      <for|para| of=get("learn.chmodIntro.content")>
        <span>${para}</span>
      </for>
    </section>

    <!-- Symbolic representation -->
    <section id="symbolic-representation" class="mb-8 border-b-3 border-gray-600 pb-4">
      <h2 class="text-3xl font-semibold mb-3 text-slate-400">${get("learn.symbolicRepresentation.title")}</h2>
      <for|para| of=get("learn.symbolicRepresentation.content")>
        <span>${para} </span>
      </for>

      <img
        src="/images/chmod-symbolic-representation.png"
        class="clip-img w-full max-w-full md:max-w-4xl mx-auto yx-2"
        title=(get('images.chmod-symbolic-representation.title'))
        alt=(get('images.chmod-symbolic-representation.alt'))
        decoding="async"
        loading="lazy"
        width="896"
      />
    </section>

    <!-- Octal representation -->
    <section id="octal-representation" class="mb-8 border-b-3 border-gray-600 pb-4">
      <h2 class="text-3xl font-semibold mb-3 text-slate-400">${get("learn.octalRepresentation.title")}</h2>
      <for|para| of=get("learn.octalRepresentation.content")>
        <span>${para} </span>
      </for>

      <img
        src="/images/chmod-numeric-representation.png"
        class="clip-img w-full max-w-full md:max-w-4xl mx-auto yx-2"
        title=(get('images.chmod-numeric-representation.title'))
        alt=(get('images.chmod-numeric-representation.alt'))
        decoding="async"
        loading="lazy"
        width="896"
      />

      <p class="mt-4">${get("learn.octalRepresentation.howCalculated")}</p>

      <img
        src="/images/chmod-calculating-file-permissions.png"
        class="clip-img w-full max-w-full md:max-w-4xl mx-auto yx-2"
        title=(get('images.chmod-calculating-file-permissions.title'))
        alt=(get('images.chmod-calculating-file-permissions.alt'))
        decoding="async"
        loading="lazy"
        width="896"
      />
    </section>

    <!-- Updating a single permission -->
    <section id="update-single-permission" class="mb-8 border-b-3 border-gray-600 pb-4">
      <h2 class="text-3xl font-semibold mb-3 text-slate-400">${get("learn.updateSinglePermission.title")}</h2>
      <for|para| of=get("learn.updateSinglePermission.content")>
        <span>${para} </span>
      </for>
      <img
        src="/images/chmod-modifying-file-permissions-command.png"
        class="clip-img w-full max-w-full md:max-w-4xl mx-auto yx-2 mt-6"
        title=(get('images.chmod-modifying-file-permissions-command.title'))
        alt=(get('images.chmod-modifying-file-permissions-command.alt'))
        decoding="async"
        loading="lazy"
        width="896"
      />
      <img
        src="/images/chmod-modifying-file-permissions-reference.png"
        class="w-full max-w-full md:max-w-4xl mx-auto yx-2"
        title=(get('images.chmod-modifying-file-permissions-reference.title'))
        alt=(get('images.chmod-modifying-file-permissions-reference.alt'))
        decoding="async"
        loading="lazy"
        width="896"
      />
    </section>

    <!-- Recursive changes -->
    <section id="recursive-changes" class="mb-8 border-b-3 border-gray-600 pb-4">
      <h2 class="text-3xl font-semibold mb-3 text-slate-400">${get("learn.recursiveChanges.title")}</h2>
      <for|para| of=get("learn.recursiveChanges.content")>
        <span>${para} </span>
      </for>
    </section>

    <!-- Ownership -->
    <section id="ownership" class="mb-8 border-b-3 border-gray-600 pb-4">
      <h2 class="text-3xl font-semibold mb-3 text-slate-400">${get("learn.ownership.title")}</h2>
      <for|para| of=get("learn.ownership.content")>
        <p>${para}</p>
      </for>
    </section>

    <!-- Special bits -->
    <section id="special-bits" class="mb-8 border-b-3 border-gray-600 pb-4">
      <h2 class="text-3xl font-semibold mb-3 text-slate-400">${get("learn.specialBits.title")}</h2>
      <p class="mb-4">${get("learn.specialBits.intro")}</p>
      <ul class="pl-0 list-none grid grid-cols-1 md:grid-cols-3 gap-3">
        <for|item| of=get("learn.specialBits.items")>
          <li class="bg-slate-900 rounded-lg p-4 border border-gray-700">
            <h3 class="text-xl font-bold mb-2">${item.name}</h3>
            <p>${item.description}</p>
          </li>
        </for>
      </ul>
    </section>

    <!-- Common presets -->
    <section id="common-presets" class="mb-8 border-b-3 border-gray-600 pb-4">
      <h2 class="text-3xl font-semibold mb-3 text-slate-400">${get("learn.commonPresets.title")}</h2>
      <p class="mb-4">${get("learn.commonPresets.intro")}</p>
      <table class="table-auto w-full border-collapse border border-gray-700">
        <thead>
          <tr class="bg-gray-800">
            <th class="border border-gray-700 p-2 text-left">Octal</th>
            <th class="border border-gray-700 p-2 text-left">Meaning</th>
          </tr>
        </thead>
        <tbody>
          <for|preset| of=get("learn.commonPresets.table")>
            <tr class="hover:bg-gray-800/50">
              <td class="border border-gray-700 p-2 font-mono">${preset.code}</td>
              <td class="border border-gray-700 p-2">${preset.description}</td>
            </tr>
          </for>
        </tbody>
      </table>

      <img
        src="/images/chmod-reference-table.png"
        class="clip-img w-full max-w-full md:max-w-4xl mx-auto yx-2 mt-6"
        title=(get('images.chmod-reference-table.title'))
        alt=(get('images.chmod-reference-table.alt'))
        decoding="async"
        loading="lazy"
        width="896"
      />
    </section>

    <!-- Debugging file permissions -->
    <section id="debugging-permissions" class="mb-8 border-b-3 border-gray-600 pb-4">
      <h2 class="text-3xl font-semibold mb-3 text-slate-400">${get("learn.debugging.title")}</h2>
      <p class="mb-4">${get("learn.debugging.intro")}</p>
      <ul class="list-disc pl-5 space-y-1">
        <for|err| of=get("learn.debugging.errors")>
          <li>
            <span class="font-semibold">${err.message}</span> - ${err.fix}
          </li>
        </for>
      </ul>
    </section>

    <!-- Security tips -->
    <section id="security-tips mb-8 border-b-3 border-gray-600 pb-4">
      <h2 class="text-3xl font-semibold mb-3 text-slate-400">${get("learn.securityTips.title")}</h2>
      <ul class="list-disc pl-5 space-y-1">
        <for|tip| of=get("learn.securityTips.points")>
          <li>${tip}</li>
        </for>
      </ul>
    </section>

  </Card>
</div>

